import * as actionTypes from '../constants/wishlistConstants';
import axios from "axios";
import store from "../store";



// export const addToWishlist = (wishlist) => async(dispatch) =>{


//     try{
//         dispatch({ type: actionTypes.WISHLIST_REQUEST });

//         const config = {
//             headers: {
//               "Content-Type": "application/json",
//             },
//           };
//         const {data} = await axios.post('/api/v1/wishlist/addToWishlist', wishlist, config);

//         dispatch({
//             type: actionTypes.WISHLIST_REQUEST_SUCCESS,
//             payload: data
//         });
//     }catch (error){
//         dispatch({
//             type: actionTypes.WISHLIST_REQUEST_FAIL,
//             payload: error.response.data.message,
//         });
//     }
// };
// export const getWishlistItems = () => async (dispatch) => {
//     try {
//       dispatch({ type: actionTypes.WISHLIST_REQUEST });
      
//       const res = await axios.post(`/api/v1/wishlist`);
//       if (res.status === 200) {
//         const { wishlist } = res.data;
//         if (wishlist) {
//           dispatch({
//             type: actionTypes.WISHLIST_REQUEST_SUCCESS,
//             payload: { wishlist },
//           });
//         }
//       }else{
//         const { error } = res.data;
//         dispatch({
//             type: actionTypes.WISHLIST_REQUEST_FAIL,
//             payload: error.response && error.response.data.message ? error.response.data.message : error.message,
//           });
//         }
//     } catch (error) {
//       console.log(error);
//     }
//   };
export const getWishlistItems = () => async(dispatch) =>{
    try{
        dispatch({ type: actionTypes.WISHLIST_REQUEST });
        const res = await axios.post ('/api/v1/wishlist');
        if (res.status === 200) {
            const {
              userWishlist: { wishlist },
            } = res.data;
            dispatch({
              type: actionTypes.WISHLIST_REQUEST_SUCCESS,
              payload: { wishlist },
            });
        }else{
            const { error } = res.data;
            dispatch({
                type: actionTypes.WISHLIST_REQUEST_FAIL,
                payload: error.response && error.response.data.message ? error.response.data.message : error.message,
            });
        }
        
    }catch (error){
        console.log(error);
    }
};
// export const getWishlistItems = () => async (dispatch) => {
//     try{
//         dispatch({ type: actionTypes.WISHLIST_REQUEST });
//         const res = await axios.get ('/api/v1/wishlist');
//         console.log(res);
//         if (res.status === 200) {
//             const {
//                 wishlistItems: { wishlist },
//             } = res.data;
//             dispatch({
//               type: actionTypes.WISHLIST_REQUEST_SUCCESS,
//               payload: { wishlist },
//             });
//         }else{
//             const { error } = res.data;
//             dispatch({
//                 type: actionTypes.WISHLIST_REQUEST_FAIL,
//                 payload: error.response && error.response.data.message ? error.response.data.message : error.message,
//             });
//         }
        
//     }catch (error){
//         console.log(error);
//     }
//   };
// export const getWishlistItems = () => async(dispatch) =>{
    // try{
    //     dispatch({ type: actionTypes.WISHLIST_REQUEST });
    //     const {data} = await axios.get(`/api/v1/wishlist`);
    //     console.log(data[0].product);

    //     dispatch({
    //         type: actionTypes.WISHLIST_REQUEST_SUCCESS,
    //         payload: data,
    //     })
    // }catch (error){
    //     dispatch({
    //         type: actionTypes.WISHLIST_REQUEST_FAIL,
    //         payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    //     });
    // }
// };

// export const addToWishlist = (product) => async (dispatch) => {

//     const {
//         wishlist: { wishlistItems },
//       } = store.getState();
    
//       dispatch({ type: actionTypes.WISHLIST_REQUEST });
      
//       const payload = {
       
//         wishlistItems: [
//           {
//             product: product._id,
//           },
//         ],
//       };

//       console.log(payload);
//       const res = await axios.post(`/api/v1/wishlist/addToWishlist`, payload);
      
//     dispatch({
//       type: actionTypes.WISHLIST_REQUEST_SUCCESS,
//       payload: { wishlistItems },
//     });
//   };



// export const addToWishlist = (product) => async(dispatch) => {

//     try{
//         dispatch({ type: actionTypes.ADD_TO_CART_REQUEST });
      
//       const payload = {
       
//         wishlistItems: [
//           {
//             product: product._id,
//           },
//         ],
//       };
      
//       console.log(payload);
//       const res = await axios.post(`/api/v1/wishlist/addToWishlist`, payload);
//       console.log(res);
//     //   if (res.status === 201) {
//     //     dispatch(getCartItems());
//     //   }
//     // } else {
//     //   localStorage.setItem("cart", JSON.stringify(cartItems));
//     // }
//     // console.log(user.isAuthenticated)
//     console.log("addToWishlist", wishlistItems);

//     dispatch({
//         type: actionTypes.WISHLIST_REQUEST_SUCCESS,
//         payload: { wishlistItems },
//       });
//     }catch(error){
//         dispatch({
//             type: actionTypes.WISHLIST_REQUEST_FAIL,
//             payload: error.response && error.response.data.message ? error.response.data.message : error.message,
//         });
//     }
//   };
//     // try {
//     //     dispatch({ type: actionTypes.WISHLIST_REQUEST });
//     //     const config = { headers: {"Content-Type": "application/json"}};

//     //     const {wlD} = await axios.post(`/api/v1/wishlist/addTowishlist`, {wishlistData}, config);
//     //     // localStorage.setItem("data", JSON.stringify(data));

//     //     dispatch({type: actionTypes.WISHLIST_REQUEST_SUCCESS, payload: wlD.product });
//     //     } catch(error){
//     //         dispatch({
//     //             type: actionTypes.WISHLIST_REQUEST_FAIL,
//     //             payload: error.response && error.response.wlD.message ? error.response.wlD.message : error.message,
//     //         });
//     // }

// export const getWishlistItem = (id) => async(dispatch) =>{
//     try{
//         dispatch({ type: actionTypes.WISHLIST_REQUEST });
//         const {data} = await axios.get(`/api/v1/wishlist/${id}`);

//         dispatch({
//             type: actionTypes.WISHLIST_REQUEST_SUCCESS,
//             payload: data,
//         })
//     }catch (error){
//         dispatch({
//             type: actionTypes.WISHLIST_REQUEST_FAIL,
//             payload: error.response && error.response.data.message ? error.response.data.message : error.message,
//         });
//     }
// };

//REMOVE WISHLIST ITEM
export const removeWishlistItem = (payload) => {
    return async (dispatch) => {
          dispatch({ type: actionTypes.REMOVE_WISHLIST_ITEM });
        try {
        const res = await axios.post(`/api/v1/wishlist/remove`, payload);
        if (res.status === 202) {
          dispatch({ type: actionTypes.REMOVE_WISHLIST_ITEM_SUCCESS });
          dispatch(getWishlistItems());
        }
         else {
          const { error } = res.data;
          dispatch({
            type: actionTypes.REMOVE_WISHLIST_ITEM_FAIL,
            payload: { error },
          });
        }
        
      } catch (error) {
        console.log(error);
      }
    };
  };
